"use strict";
/**
 * Created by dzmitry.barkouski on 12.12.2016.
 **/
(function (window) {
  window.PlanWidget = {};
  /******************************
   Check DOM Ready function
   *******************************/
  /*
   jQuery's document.ready/$(function(){}) should
   you wish to use a cross-browser DOMReady solution
   without opting for a library.

   Demo: http://jsfiddle.net/9CWtz/

   usage:
   _docR(function(){
   // your code
   });

   Parts: jQuery project, Diego Perini, Lucent M.
   This version: Addy Osmani
   */
  
  /*
   **Edited: Barkouski Dzmitry on 12.12.2016
   */
  // Define a local copy of _docR
  var _docR = function (callback) {
      readyBound = false;
      _docR.isReady = false;
      if (typeof callback === 'function') {
        DOMReadyCallback = callback;
      }
      bindReady();
    },
    // Use the correct document accordingly with window argument (sandbox)
    document = window.document,
    readyBound = false,
    DOMReadyCallback = function () {
    },
    // The ready event handler
    DOMContentLoaded;
  // Is the DOM ready to be used? Set to true once it occurs.
  _docR.isReady = false;
  // Handle when the DOM is ready
  var DOMReady = function () {
    // Make sure that the DOM is not already loaded
    if (!_docR.isReady) {
      // Make sure body exists, at least, in case IE gets a little overzealous (ticket #5443).
      if (!document.body) {
        setTimeout(DOMReady, 13);
        return;
      }
      // Remember that the DOM is ready
      _docR.isReady = true;
      // If there are functions bound, to execute
      DOMReadyCallback();
      // Execute all of them
    }
  }; // /ready()
  var bindReady = function () {
    if (readyBound) {
      return;
    }
    readyBound = true;
    // Catch cases where _docR is called after the
    // browser event has already occurred.
    if (document.readyState === "complete") {
      DOMReady();
    }
    // Mozilla, Opera and webkit nightlies currently support this event
    if (document.addEventListener) {
      // Use the handy event callback
      document.addEventListener("DOMContentLoaded", DOMContentLoaded, false);
      // A fallback to window.onload, that will always work
      window.addEventListener("load", DOMContentLoaded, false);
      // If IE event model is used
    } else if (document.attachEvent) {
      // ensure firing before onload,
      // maybe late but safe also for iframes
      document.attachEvent("onreadystatechange", DOMContentLoaded);
      // A fallback to window.onload, that will always work
      window.attachEvent("onload", DOMContentLoaded);
      // If IE and not a frame
      // continually check to see if the document is ready
      var toplevel = false;
      try {
        toplevel = window.frameElement === null;
      } catch (e) {
      }
      if (document.documentElement.doScroll && toplevel) {
        doScrollCheck();
      }
    }
  }; // /bindReady()
  // The DOM ready check for Internet Explorer
  var doScrollCheck = function () {
    if (_docR.isReady) {
      return;
    }
    try {
      // If IE is used, use the trick by Diego Perini
      // http://javascript.nwbox.com/IEContentLoaded/
      document.documentElement.doScroll("left");
    } catch (error) {
      setTimeout(doScrollCheck, 1);
      return;
    }
    // and execute any waiting functions
    DOMReady();
  }; // /doScrollCheck()
  // Cleanup functions for the document ready method
  if (document.addEventListener) {
    DOMContentLoaded = function () {
      document.removeEventListener("DOMContentLoaded", DOMContentLoaded, false);
      DOMReady();
    };
  } else if (document.attachEvent) {
    DOMContentLoaded = function () {
      // Make sure body exists, at least, in case IE gets a little overzealous (ticket #5443).
      if (document.readyState === "complete") {
        document.detachEvent("onreadystatechange", DOMContentLoaded);
        DOMReady();
      }
    };
  } // /if()
  /******************************
   END
   *******************************/
  _docR(function () {
    /******************************
     Check and Load right jQuery ver.
     *******************************/
    var jQuery;
    
    /******** Load jQuery if not present *********/
    if (window.jQuery === undefined || window.jQuery.fn.jquery !== '1.9.0') {
      var script_tag = document.createElement('script');
      script_tag.setAttribute("type", "text/javascript");
      script_tag.setAttribute("src",
        "https://ajax.googleapis.com/ajax/libs/jquery/1.9.0/jquery.min.js");
      if (script_tag.readyState) {
        script_tag.onreadystatechange = function () { // For old versions of IE
          if (this.readyState === 'complete' || this.readyState === 'loaded') {
            scriptLoadHandler();
          }
        };
      } else { // Other browsers
        script_tag.onload = scriptLoadHandler;
      }
      // Try to find the head, otherwise default to the documentElement
      (document.getElementsByTagName("head")[0] || document.documentElement).appendChild(script_tag);
    } else {
      // The jQuery version on the window is the one we want to use
      jQuery = window.jQuery;
      main();
    }
    
    /******** Called once jQuery has loaded ******/
    function scriptLoadHandler() {
      // Restore $ and window.jQuery to their previous values and store the
      // new jQuery in our local jQuery variable
      jQuery = window.jQuery.noConflict(true);
      // Call our main function
      main(jQuery);
    }
    
    /******************************
     END
     *******************************/
    
    
    
    
    function main(jQuery) {
      if (!window.jQuery) {
        window.jQuery = window.$ = jQuery;
      } else if (!window._jQuery_PW) {
        window._jQuery_PW = jQuery;
      }
      jQuery(document).ready(function ($) {
          var localVars = {
            widgetName: 'currentWidget',
            anchor_jQObj: null, //anchor (jQuery object) for events trigger + DOM anchor for render widget,
            anchorNameAttr: 'data-planWidget',
            anchorParamsAttr: 'data-widgetViewParams',
            imgMap_selector: '[data-objtype="img_map"]',
            zoomImgMap_selector: '[data-objtype="zoom-img"]',
            imgMapWr_selector: '[data-objtype="img_mapWr"]',
            fullScreenBtn_selector: '[data-objtype="FSBtn"]',
            zoomInBtn_selector: '[data-objtype="ZIBtn"]',
            zoomOutBtn_selector: '[data-objtype="ZOBtn"]',
            cancelZoomBtn_selector: '[data-objtype="CZBtn"]',
            hammerAnchor_selector: '[data-objtype="img_hammerAnchor"]',
            popupWindow_selector: '[data-objtype="popupWindow"]',
            popupWindow_mapWindow_selector: '[data-objtype="mapWindow"]',
            popupWindow_companyLogo_selector: '[data-objtype="companyLogo"]',
            popupWindow_popupInfo_selector: '[data-objtype="popupInfo"]',
            closePopupBtn_selector: '[data-objtype="ClosePopupBtn"]',
            area_selector: 'area',
            zoomStep: 600,
            deltaX: 0,
            deltaY: 0,
            bgPosX: 0,
            bgPosY: 0,
            widgetViewParams: {
              'class': 'plan-widget'
            },
            debug: false,
          };
          var clipper = require('clipper-lib');
          var api = {
            // addScripts: function (/*string or array of strings*/ scripts) {
            //   var scriptsPromise = $.Deferred();
            //   var promisesArray = [];
            //   var head = $('head');
            //   var addOneScript = function (/*string*/ script) {
            //     if (typeof script === 'string' && script.length) {
            //       var script_tag = document.createElement('script');
            //       var script_Promise = $.Deferred();
            //       promisesArray.push(script_Promise.promise());
            //
            //       var scriptLoad_Handler = function () {
            //         script_Promise.resolve();
            //       };
            //
            //       script_tag.setAttribute("type", "text/javascript");
            //       script_tag.setAttribute("src", script);
            //       script_tag.setAttribute("async", true);
            //       if (script_tag.readyState) {
            //         script_tag.onreadystatechange = function () { // For old versions of IE
            //           if (this.readyState === 'complete' || this.readyState === 'loaded') {
            //             scriptLoad_Handler();
            //           }
            //         };
            //       } else { // Other browsers
            //         script_tag.onload = scriptLoad_Handler;
            //       }
            //       // Try to find the head, otherwise default to the documentElement
            //       (document.getElementsByTagName("head")[0] || document.documentElement).appendChild(script_tag);
            //     }
            //   };
            //   if (scripts && scripts.length) {
            //     if ($.isArray(scripts)) {
            //       scripts.forEach(addOneScript);
            //     } else {
            //       addOneScript(scripts);
            //     }
            //   }
            //   $.when.apply($, promisesArray).then(function () {
            //     scriptsPromise.resolve();
            //   });
            //
            //   return scriptsPromise.promise();
            // },
            // addStyles: function (/*string or array of strings*/ styles) {
            //   var head = $('head');
            //   var addOneStyle = function (/*string*/ style) {
            //     if (typeof style === 'string' && style.length) {
            //       var style_tag = '<link rel="stylesheet" type="text/css" href="' + style + '" />';
            //       head.append(style_tag);
            //     }
            //   };
            //   if (styles && styles.length) {
            //     if ($.isArray(styles)) {
            //       styles.forEach(addOneStyle);
            //     } else {
            //       addOneStyle(styles);
            //     }
            //   }
            // },
            
            stopWheel: function (e) {
              if (!e) { /* IE7, IE8, Chrome, Safari */
                e = window.event;
              }
              if (e.preventDefault) { /* Chrome, Safari, Firefox */
                e.preventDefault();
              }
              e.returnValue = false;
              /* IE7, IE8 */
            },
            disablePageScroll: function () {
              var self = this;
              $(localVars.hammerAnchor_selector).hover(function () {
                $(document).bind('mousewheel DOMMouseScroll', function (event) {
                  // console.log(event);
                  self.stopWheel(event);
                });
              }, function () {
                $(document).unbind('mousewheel DOMMouseScroll');
              });
            },
            colorsMethods: {
              hexToRgb: function (hex) {
                var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
                hex = hex.replace(shorthandRegex, function (m, r, g, b) {
                  return r + r + g + g + b + b;
                });
                
                var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
                return result ? [
                  /*r: */
                  parseInt(result[1], 16),
                  /*g: */
                  parseInt(result[2], 16),
                  /*b: */
                  parseInt(result[3], 16)
                ] : null;
              },
              rgbToHsl: function (rgb) {
                var r = parseInt(rgb[0], 16) / 255,
                  g = parseInt(rgb[1], 16) / 255,
                  b = parseInt(rgb[2], 16) / 255;
                var max = Math.max(r, g, b), min = Math.min(r, g, b);
                var h, s, l = (max + min) / 2;
                if (max == min) {
                  h = s = 0;
                } else {
                  var d = max - min;
                  s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
                  switch (max) {
                    case r:
                      h = (g - b) / d + (g < b ? 6 : 0);
                      break;
                    case g:
                      h = (b - r) / d + 2;
                      break;
                    case b:
                      h = (r - g) / d + 4;
                      break;
                  }
                  h /= 6;
                }
                return [
                  h,
                  s,
                  l
                ];
              },
              getTextColor: function (color) {
                var e,
                  fc;
                if (/rgb/.test(color)) {
                  color = color.split(',');
                  $.each(color, function (i, c) {
                    color[i] = parseInt(c.replace(/\D/gi, ''), 10);
                  });
                  // color = color.slice(0,3).join('');
                  e = api.colorsMethods.rgbToHsl(color);
                } else if (/#/.test(color)) {
                  e = api.colorsMethods.rgbToHsl(api.colorsMethods.hexToRgb(color));
                } else if (/hsl/.test(color)) { //hsl(38.8,100%,50%)
                  color = color.split(',');
                  $.each(color, function (i, c) {
                    color[i] = parseInt(c.replace(/\D/gi, ''), 10) / 100;
                  });
                  e = color;
                }
                if (typeof e !== "undefined" && ((e[0] < 0.55 && e[2] >= 0.5) || (e[0] >= 0.55 && e[2] >= 0.75))) {
                  fc = '#000000'; // черный
                } else {
                  fc = '#FFFFFF'; // белый
                }
                return fc;
              }
            },
            setParams: function (params) {
              params = (params && typeof params === 'object') ? params : {};
              $.extend(true, localVars, params);
              if (localVars.inited && localVars.anchor_jQObj && localVars.anchor_jQObj instanceof $) {
                localVars.anchor_jQObj.trigger('params:updated');
              }
            },
            parseWidgetParams: function (jQObj) {
              var paramsString = jQObj.attr(localVars.anchorParamsAttr) || jQObj.attr(localVars.anchorParamsAttr.toLowerCase());
              if (paramsString && paramsString.length) {
                paramsString = JSON.parse(paramsString);
              }
              return (paramsString && typeof paramsString === 'object') ? paramsString : {};
            },
            initWidget: function () {
              var self = this;

              $('script[' + localVars.anchorNameAttr + ']')
                .add($('script[' + localVars.anchorNameAttr.toLowerCase() + ']')).each(function () {
                if (!$(this).data('inited') && !localVars.anchor_jQObj) {
                  localVars.anchor_jQObj = $(this);
                }
              });
              if (localVars.anchor_jQObj && localVars.anchor_jQObj instanceof $) {
                var tempWidgetName = localVars.anchor_jQObj.attr(localVars.anchorNameAttr);
                if (tempWidgetName && tempWidgetName.length) {
                  window[tempWidgetName] = window[tempWidgetName] || {};
                  window[tempWidgetName] = $.extend({}, publicApi, window[tempWidgetName]);
                }
                
                self.setParams(self.parseWidgetParams(localVars.anchor_jQObj));
                
                localVars.widgetViewWr_jQOBj = $('<div></div>');
                localVars.widgetViewWr_jQOBj.css(localVars.widgetViewParams).addClass(localVars.widgetViewParams.class);
                localVars.anchor_jQObj.after(localVars.widgetViewWr_jQOBj);
                localVars.anchor_jQObj.data({'inited': true});
                localVars.inited = true;
              }
            },
            renderMap: function () {
              var paramsString = localVars.anchor_jQObj.attr(localVars.anchorParamsAttr) || localVars.anchor_jQObj.attr(localVars.anchorParamsAttr.toLowerCase());
              
              if (paramsString && paramsString.length) {
                paramsString = JSON.parse(paramsString);
              }

              var imgLoadDefer = $.Deferred(),
                template = require('./templates/main.hbs'),
                compiledRendered = template(paramsString.planWidgetObjects);
              
              localVars.widgetViewWr_jQOBj.html(compiledRendered);
              
              //set link for jquery objects
              localVars.imageMap_jQObj = $(localVars.imgMap_selector);
              localVars.imageMap_jQObj[0].onload = function () {
                localVars.imageMapRatio = localVars.imageMap_jQObj.innerHeight() / localVars.imageMap_jQObj.innerWidth();
                imgLoadDefer.resolve();
              };
              
              localVars.imageMapWr_jQObj = $(localVars.imgMapWr_selector);
              localVars.zoomImgMap_jQObj = $(localVars.zoomImgMap_selector);
              localVars.hammerAnchor_jQObj = $(localVars.hammerAnchor_selector);
              localVars.popupWindow_jQObj = $(localVars.popupWindow_selector);
              localVars.popupWindow_mapWindow_jQObj = $(localVars.popupWindow_mapWindow_selector);
              localVars.popupWindow_popupInfo_jQObj = $(localVars.popupWindow_popupInfo_selector);
              localVars.closePopupBtn_jQObj = $(localVars.closePopupBtn_selector);
              
              return imgLoadDefer.promise();
            },
            
            addButtonsEventsListeners: function () {
              
              var self = this;
              localVars.widgetViewWr_jQOBj
                .find(localVars.fullScreenBtn_selector)
                .off('click').on('click', function () {
                  self.toggleFullScreen(localVars.widgetViewWr_jQOBj[0]);
                })
                .end()
                .find(localVars.zoomInBtn_selector)
                .off('click').on('click', self.btnsHandlers.zoomIn)
                .end()
                .find(localVars.zoomOutBtn_selector)
                .off('click').on('click', self.btnsHandlers.zoomOut)
                .end()
                .find(localVars.cancelZoomBtn_selector)
                .off('click').on('click', self.btnsHandlers.cancelZoom)
                .end()
                .find(localVars.closePopupBtn_jQObj)
                .off('click').on('click', function () {
                self.closePopup();
              });
            },
            btnsHandlers: {
              zoomIn: function () {
                localVars.zoomInSize = localVars.zoomInSize || localVars.imageMap_jQObj.innerWidth();
                if (localVars.zoomInTimer) {
                  clearTimeout(localVars.zoomInTimer);
                  delete localVars.zoomInTimer;
                }
                localVars.zoomInSize += localVars.zoomStep;
                localVars.zoomInTimer = setTimeout(function () {
                  localVars.imageMap_jQObj
                    .mapster('resize', localVars.zoomInSize, 0, 500, false, true);
                  delete localVars.zoomInSize;
                  delete localVars.zoomInTimer;
                }, 50);
              },
              zoomOut: function () {
                localVars.zoomOutSize = localVars.zoomOutSize || localVars.imageMap_jQObj.innerWidth();
                if (localVars.zoomOutTimer) {
                  clearTimeout(localVars.zoomOutTimer);
                  delete localVars.zoomOutTimer;
                }
                localVars.zoomOutSize -= localVars.zoomStep;
                localVars.zoomOutTimer = setTimeout(function () {
                  var minWidth = localVars.imageMapWr_jQObj.width();
                  if (localVars.zoomOutSize < minWidth) {
                    localVars.imageMap_jQObj
                      .mapster('resize', minWidth, 0, 500, false, true);
                  } else {
                    localVars.imageMap_jQObj
                      .mapster('resize', localVars.zoomOutSize, 0, 500, false, true);
                  }
                  delete localVars.zoomOutSize;
                  delete localVars.zoomOutTimer;
                }, 50);
                
                
              },
              cancelZoom: function () {
                    var width = localVars.imageMapWr_jQObj.innerWidth();
                    api.changeImgPosition(0, 0, true);
                    localVars.imageMap_jQObj
                        .mapster('resize', width, 0, 100, false, true);
              }
            },
            zoomWhellMap: function () {
              localVars.panElParentJQO
                .on('mouseenter', function () {
                  localVars.panElParentJQO.on('wheel mousewheel', api.onwheel);
                })
                .on('mouseleave', function () {
                  // localVars.mapster_obj
                  //   .stop('pan');
                  localVars.panElParentJQO.off('wheel mousewheel');
                });
            },
            onwheel: function (e) {
              if ((e && e.originalEvent) && (e.originalEvent.wheelDelta || e.originalEvent.deltaY)) {
                if (localVars.resizeImgTimer) {
                  clearTimeout(localVars.resizeImgTimer);
                  delete localVars.resizeImgTimer;
                }
                if (e.originalEvent.wheelDelta) {
                  if (e.originalEvent.wheelDelta > 0) {
                    localVars.resizeImgTimer = setTimeout(function () {
                      api.btnsHandlers.zoomIn();
                    }, 15);
                  } else {
                    localVars.resizeImgTimer = setTimeout(function () {
                      api.btnsHandlers.zoomOut();
                    }, 15);
                  }
                } else if (e.originalEvent.deltaY) {
                  if (e.originalEvent.deltaY < 0) {
                    localVars.resizeImgTimer = setTimeout(function () {
                      api.btnsHandlers.zoomIn();
                    }, 15);
                  } else {
                    localVars.resizeImgTimer = setTimeout(function () {
                      api.btnsHandlers.zoomOut();
                    }, 15);
                  }
                }
              }
            },
            getAreaPopupHTML: function (key) {
              var template;
              switch (localVars.customerDb) {
                case "capsule_cbredemo":
                case "capsule_cbrews":
                  template = require("./templates/cbre-form.hbs");
                  break;
                default:
                  template = require("./templates/form.hbs");
                  break;
              }
              var areaData = {};
              for (var i = localVars.planWidgetObjects.mapAreas.length; i--;) {
                if (localVars.planWidgetObjects.mapAreas[i].polygonName === key) {
                  areaData = localVars.planWidgetObjects.mapAreas[i];
                  break;
                }
              }
              if(areaData['popup'] && areaData['popup']['bgColor']){
                 api.setDialogColor(areaData['popup']['bgColor']);
              }
              if(areaData['popup']){
                if(areaData['popup']['showAgents'] && (areaData['popup']['showAgents'] == "false")){
                  areaData['popup']['showAgents'] = false;
                }
                if(areaData['popup']['showDocuments'] && (areaData['popup']['showDocuments'] == "false")){
                  areaData['popup']['showDocuments'] = false;
                }
                if(areaData['popup']['showPhotos'] && (areaData['popup']['showPhotos'] == "false")){
                  areaData['popup']['showPhotos'] = false;
                }
                if(areaData['popup']['showDescription'] && (areaData['popup']['showDescription'] == "false")){
                  areaData['popup']['showDescription'] = false;
                }
              }
              
              return template(areaData);
            },
            getMapsterAreas: function () {
              var mapsterAreas = [],
                self = this;
              localVars.planWidgetObjects.mapAreas.forEach(function (el) {
                var description = (el && el['popup'] && el['popup']['description']) ? el['popup']['description']: '';
                  el.toolTipCss = el.toolTipCss || {};
                  mapsterAreas.push({
                    key: el.polygonName,
                    /*toolTip: el.tooltipTitle+' '+description,*/
                    toolTip: el.tooltipTitle,
                    toolTipCss: $.extend({
                      'background-color': 'rgb(246, 246, 239)',
                      'color': function () {
                        return (typeof this['background-color'] === 'string' && this['background-color'].length)
                          ? self.colorsMethods.getTextColor(this['background-color'])
                          : '#000';
                      }
                    }, el.toolTipCss)
                  });
                }
              );
              return mapsterAreas;
              
            },
            initMapster: function (img_jQObj) {
              var self = this;
              // plan_types was not present in previous json_viewer_cache, so explicitly setting here
              if (!localVars.planWidgetObjects.hasOwnProperty('plan_type')) {
                localVars.planWidgetObjects.plan_type = "normal";
              }
              img_jQObj.mapster({
                fillOpacity: localVars.planWidgetObjects.plan_type == "normal" ? 0.3 : 1,
                fillColor: localVars.planWidgetObjects.plan_type == "normal" ? "CECCCC" : "FFFFFF",
                strokeColor: "000000",
                strokeWidth: 1,
                stroke: false,
                scaleMap: true,
                isSelectable: true,
                singleSelect: false,
                mapKey: 'name',
                showToolTip: true,
                toolTipClose: [
                  "tooltip-click",
                  "area-click",
                  'area-mouseout'
                ],
                toolTipRenderPlace: '#mapster_wrap_0',
                // toolTipContainer: '<span></span>',
                onClick: localVars.planWidgetObjects.plan_type == "normal" ? self.showPopup : null,
                onMouseover: function (event) {
                    if(typeof planMediator !== 'undefined') {
                      planMediator.emitEvent('highlightCharts', [event.key]);
                    }
                  localVars._preventPopup = false;
                    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
                      api.showPopup({key:event.key});
                    }
                },
                  onMouseout:function (event) {
                    if(typeof planMediator !== 'undefined') {
                      planMediator.emitEvent('clearHighlightCharts', [event.key]);
                    }
                  },
                onConfigured: function () {
                  localVars.imageMap_jQObj.addClass('drag-image');
                  localVars.hammerAnchor_jQObj = $('#mapster_wrap_0');

                  $(window)
                    .off('resize' + '.' + localVars.widgetName, self.resizeImgMap)
                    .on('resize' + '.' + localVars.widgetName, self.resizeImgMap)
                    .trigger('resize' + '.' + localVars.widgetName);
                },
                areas: self.getMapsterAreas()

              });
            },
            setDialogColor: function (color) {
              $('.zoom-block__right').css("background-color", color);
            },
            resizeImgMap: function () {
              if (localVars.resizeImgTimer) {
                clearTimeout(localVars.resizeImgTimer);
                delete localVars.resizeImgTimer;
              }
              localVars.resizeImgTimer = setTimeout(function () {
                var imageMapWrWidth = localVars.imageMapWr_jQObj.innerWidth();
                localVars.imageMap_jQObj.mapster('resize', imageMapWrWidth, 0, 100);
                delete localVars.resizeImgTimer;
              }, 100);
            },
            toggleFullScreen: function (documentElement) {
              var rootContainer;
              if (!document.fullscreenElement &&    // alternative standard method
                !document.mozFullScreenElement && !document.webkitFullscreenElement && !document.msFullscreenElement && documentElement) {  // current working methods
                if (documentElement.requestFullscreen) {
                  documentElement.requestFullscreen();
                } else if (documentElement.mozRequestFullScreen) {
                  documentElement.mozRequestFullScreen();
                } else if (documentElement.webkitRequestFullscreen) {
                  documentElement.webkitRequestFullscreen(documentElement.ALLOW_KEYBOARD_INPUT);
                } else if (documentElement.msRequestFullscreen) {
                  documentElement.msRequestFullscreen();
                }
                if (document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement) {
                  // $(documentElement).addClass('is-fullScreen');
                  rootContainer = localVars.widgetViewWr_jQOBj;
                }
              } else {
                if (document.cancelFullScreen) {
                  document.cancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                  document.mozCancelFullScreen();
                } else if (document.webkitCancelFullScreen) {
                  document.webkitCancelFullScreen();
                } else if (document.msExitFullscreen) {
                  document.msExitFullscreen();
                }
                rootContainer = $('body');
                // $('.is-fullScreen').removeClass('is-fullScreen');
              }
  
              if (window.lightbox && $.isFunction(window.lightbox.option) && $.isFunction(window.lightbox.init) && $.isFunction(window.lightbox.end)) {
                window.lightbox.end();
                window.lightbox.option({
                  'rootContainer': rootContainer
                });
                window.lightbox.init();
              }
            },
            changeImgPosition: function (x, y, abs, not_save) {
              var panMapImage = localVars.hammerAnchor_jQObj[0];
              if (!not_save) {
                localVars.deltaX = x;
                localVars.deltaY = y;
              }
              if (!abs) {
                x += localVars.deltaX;
                y += localVars.deltaY;
              }
              panMapImage.style.left = x + "px";
              panMapImage.style.top = y + "px";
            },
            areaTools: {
              convertCoords: function (coordsString) {
                var coords = [];
                if (coordsString && coordsString.search(/,/) >= 0) {
                  var tempCoords = coordsString.split(',');
                  if ($.isArray(tempCoords)) {
                    for (var i = 0, l = tempCoords.length; i < l; i++) {
                      coords.push({
                        x: parseInt(tempCoords[i], 10),
                        y: parseInt(tempCoords[++i], 10)
                      });
                    }
                  }
                }
                return coords;
              },
              getAreaParams: function (coords) {
                var params = {};
                
                if ($.isArray(coords) && coords.length) {
                  params = {
                    topLeftCoord: {
                      x: coords[0].x,
                      y: coords[0].y
                    },
                    bottomRightCoord: {
                      x: 0,
                      y: 0
                    }
                  };
                  coords.forEach(function (coord) {
                    params.topLeftCoord.x = (params.topLeftCoord.x < coord.x) ? params.topLeftCoord.x : coord.x;
                    params.topLeftCoord.y = (params.topLeftCoord.y < coord.y) ? params.topLeftCoord.y : coord.y;
                    params.bottomRightCoord.x =
                      (params.bottomRightCoord.x > coord.x) ? params.bottomRightCoord.x : coord.x;
                    params.bottomRightCoord.y =
                      (params.bottomRightCoord.y > coord.y) ? params.bottomRightCoord.y : coord.y;
                  });
                  params.size = {
                    w: params.bottomRightCoord.x - params.topLeftCoord.x,
                    h: params.bottomRightCoord.y - params.topLeftCoord.y
                  };
                }
                
                return params;
              }
              ,
              getZoomScale: function (areaSize, windowSize) {
                if ((windowSize.w / windowSize.h) < (areaSize.w / areaSize.h)) {
                  return windowSize.w / areaSize.w * 0.9;
                }
                
                return windowSize.h / areaSize.h * 0.9;
              }
            },
            zoomInMap: function (popupWindow_mapWindow_jQObj, area_jQObj, heightOffset) {
              heightOffset = heightOffset || 0;
              localVars.deltaX = parseInt(localVars.hammerAnchor_jQObj.css('left'), 10);
              localVars.deltaY = parseInt(localVars.hammerAnchor_jQObj.css('top'), 10);

              var self = this;
              var mapWindow = {
                  size: {
                    w: popupWindow_mapWindow_jQObj.width(),
                    h: popupWindow_mapWindow_jQObj.height()
                  },
                  offset: popupWindow_mapWindow_jQObj.offset()
                },
                currentArea = {
                  coords: self.areaTools.convertCoords(area_jQObj.attr('coords'))
                };
              
              var img = {
                size: {
                  w: localVars.hammerAnchor_jQObj.width(),
                  h: localVars.hammerAnchor_jQObj.height()
                },
                offset: localVars.hammerAnchor_jQObj.offset()
              };
              img.offset.left -= localVars.deltaX;
              img.offset.top -= localVars.deltaY;
              localVars.lastImgSize = {
                w: localVars.hammerAnchor_jQObj.width(),
                h: localVars.hammerAnchor_jQObj.height()
              };
              $.extend(currentArea, self.areaTools.getAreaParams(currentArea.coords));
              /*
              if(currentArea.size['w'] < 25 || currentArea.size['h'] < 25){
                var zoomScale = self.areaTools.getZoomScale(currentArea.size, mapWindow.size)/2;
              }else{
                var zoomScale = self.areaTools.getZoomScale(currentArea.size, mapWindow.size);
              }
              */
              var zoomScale = self.areaTools.getZoomScale(currentArea.size, mapWindow.size);

              mapWindow.topLeftCoord = {
                x: mapWindow.offset.left - img.offset.left,
                y: mapWindow.offset.top - img.offset.top
              };
              var coordsOffset = {
                x: (currentArea.topLeftCoord.x) * zoomScale/* - mapWindow.topLeftCoord.x*/,
                y: (currentArea.topLeftCoord.y) * zoomScale - heightOffset
              };
              
              var dX = coordsOffset.x;
              var dY = coordsOffset.y;
              dY -= mapWindow.size.h / 2 - currentArea.size.h * zoomScale / 2;
              dX -= mapWindow.size.w / 2 - currentArea.size.w * zoomScale / 2;
              
              var w = img.size.w * zoomScale,
                h = img.size.h * zoomScale;
              localVars.zoomImgMap_jQObj.css({
                top: -dY + 'px',
                left: -dX + 'px'
              }).attr({
                width: w,
                height: h
              });
              
              localVars.zoomImgMap_jQObj
                .find('svg')
                .attr({
                  width: w,
                  height: h
                });
              localVars.zoomImgMap_jQObj.find('svg')[0].setAttribute('viewBox', '0 0 ' + w + ' ' + h);
              
              var polygonCoords,
                temp = [];
              currentArea.coords.forEach(function (el) {
                temp.push({
                  X: el.x * zoomScale,
                  Y: el.y * zoomScale
                });
              });
              
              var cClipper = new clipper.ClipperOffset(2, 0.25),
                solution = new clipper.Paths(),
                subj = new clipper.Paths();
              subj[0] = temp;
              cClipper.AddPaths(subj, clipper.JoinType.jtRound, clipper.EndType.etClosedPolygon);
              cClipper.Execute(solution, 10);
              polygonCoords = solution[0];
              
              var tmp = require('./templates/svg_polygon.hbs'),
                polygon = $(tmp({coords: polygonCoords}));
              
              polygon.attr({
                stroke: "rgba(0, 0, 0, .2)",
                fill: "rgba(255, 255, 255, 1)"
              });
              localVars.zoomImgMap_jQObj.find('mask').html(polygon);
              
              if (localVars.debug) {
                polygon.attr({
                  fill: 'rgba(252, 168, 5, .5)',
                  stroke: 'rgba(252, 168, 5, 1)'
                });
                localVars.zoomImgMap_jQObj.find('g').last().html(polygon);
              }
              
              localVars.zoomImgMap_jQObj.html(localVars.zoomImgMap_jQObj.html());
            },
            showPopup: function (area_el) {
              if (localVars._preventPopup) {
                delete localVars._preventPopup;
                return;
              }
              if (document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement) {
                $('.plan-widget__zoom-block')
                  .css('height', (parseFloat(localVars.widgetViewParams['height']) - 50) + 'px');
              }
              
              var area = api.getAreaPopupHTML(area_el.key);
              if (localVars.popupWindow_jQObj && localVars.popupWindow_jQObj instanceof $) {
                localVars.popupWindow_popupInfo_jQObj.html(area);
                if ( localVars.privacy_notice ) {
                  localVars.popupWindow_popupInfo_jQObj.append(localVars.privacy_notice);
                }
                localVars.popupWindow_jQObj.css({'opacity': 0}).addClass('open');
                localVars.popupWindow_companyLogo_jQObj =
                  localVars.popupWindow_jQObj.find(localVars.popupWindow_companyLogo_selector);

                api.zoomInMap(localVars.popupWindow_mapWindow_jQObj, $('area[name="' + area_el.key + '"]'));
                localVars.popupWindow_jQObj.animate({'opacity': 1}, 250);
              }
            },
            closePopup: function () {
              var self = api;
              localVars.popupWindow_jQObj.removeClass('open');
              
              // localVars.hammerAnchor_jQObj.removeClass('is-zoomed');
              localVars.zoomImgMap_jQObj.css({
                width: '',
                top: '',
                left: ''
              });
              localVars.imageMap_jQObj.mapster('resize', localVars.lastImgSize.w, 0, 100);
              self.changeImgPosition(localVars.deltaX, localVars.deltaY, true, true);
            }
            ,
            panMap: function () {
              var panElement = localVars.hammerAnchor_jQObj[0],
                panElParentJQO = localVars.panElParentJQO = localVars.hammerAnchor_jQObj.parents().first();
              
              var mc = new Hammer.Manager(panElParentJQO[0], {
                domEvents: true
              });
              
              mc.add(new Hammer.Pan({
                direction: Hammer.DIRECTION_ALL,
                threshold: 0
              }));
              
              mc.on('panstart', function () {
                localVars.deltaX = parseInt(localVars.hammerAnchor_jQObj.css('left'), 10);
                localVars.deltaY = parseInt(localVars.hammerAnchor_jQObj.css('top'), 10);
                // localVars.hammerAnchor_jQObj.addClass('is-no-animation');
                localVars.deltaX = (isNaN(localVars.deltaX)) ? 0 : localVars.deltaX;
                localVars.deltaY = (isNaN(localVars.deltaY)) ? 0 : localVars.deltaY;
              });
              mc.on('panmove', function (e) {
                var dX = localVars.deltaX + (e.deltaX);
                var dY = localVars.deltaY + (e.deltaY);
                // panMapImage = localVars.hammerAnchor_jQObj[0];
                
                panElement.style.left = dX + "px";
                panElement.style.top = dY + "px";
              });
              
              mc.on('panend', function (e) {
                // localVars.hammerAnchor_jQObj.removeClass('is-no-animation');
                localVars.deltaX = localVars.deltaX + e.deltaX;
                localVars.deltaY = localVars.deltaY + e.deltaY;
                if (typeof localVars._preventPopup === 'boolean') {
                  localVars._preventPopup = true;
                }
              });
            }
          };
          
          var publicApi = {
            highlightSpaces: function (id, color) {
              var config = this.getHighlightConf();
              if(color) {
                  config.fillColor = color;
              }
              if(localVars.planWidgetObjects.plan_type == "stacking") {
                config.fillOpacity = 1;
              }
              $('#plan-map [name="'+id+'"]').trigger('mouseover');
              // localVars.imageMap_jQObj.mapster('tooltip', id);
              localVars.imageMap_jQObj.mapster('set', true, id, config);
            },
            clearHighlightSpaces: function (id) {
              var config = this.getHighlightConf();
              localVars.imageMap_jQObj.mapster('tooltip');
              localVars.imageMap_jQObj.mapster('set', false, id, config);
            },
            selectSpaces: function (id) {
              if (this.selectedSpace && this.selectedSpace === id) return;
              this.selectedSpace = id;
              $('[name="' + id + '"]')
                .click()
                .mapster('select');
                if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
                    this.openPopUp(id);
                }
            },
            closeSpacesPopup: function () {
              delete this.selectedSpace;
              api.closePopup();
            },
            getHighlightConf: function () {
              if (!localVars.planWidgetObjects.hasOwnProperty('plan_type')) {
                localVars.planWidgetObjects.plan_type = "normal";
              }
              this.conf = {
                fillOpacity: localVars.planWidgetObjects.plan_type == "normal" ? 0.3 : 0,
                fillColor: localVars.planWidgetObjects.plan_type == "normal" ? "CECCCC" : "FFFFFF",
                strokeColor: "000000"
              };
              return this.conf;
            },
            openPopUp: function (id) {
              var obj = {
                key:id
              };
               api.showPopup(obj);
            },
            toggleFullScreen: function () {
               api.toggleFullScreen(localVars.widgetViewWr_jQOBj[0]);
            }
            
          };
          
          require('./css/style.scss');
          require('./js/jquery.imagemapster[fixed].js');
          require('./js/lightbox-plus-jquery[fixed].js');
          require('./js/template7.min.js');
          window.Hammer = require('./js/hammer.min.js');
          require('./js/hammer-time.min.js');
          require('./js/plan-widget-objects.js');
          require('./js/validator.js');
          if (!localVars.inited) {
            api.initWidget();
          }
          api.renderMap().done(function () {
            api.addButtonsEventsListeners();
            api.initMapster(localVars.imageMap_jQObj);
            api.panMap();
            $('.p-loader').addClass('disabled');
            // api.zoomWhellMap();
            // api.disablePageScroll();
          });
          /* api.addStyles('css/style.scss');
           api.addScripts([
           'js/jquery.imagemapster[fixed].js',
           'js/lightbox-plus-jquery.min.js',
           'js/template7.min.js',
           'js/hammer.min.js',
           'js/hammer-time.min.js',
           'js/plan-widget-objects.js'
           ]).done(function () {
           if (!localVars.inited) {
           api.initWidget();
           }
           api.renderMap(window.planWidgetObjects).done(function () {
           api.addButtonsEventsListeners();
           api.initMapster(localVars.imageMap_jQObj);
           api.addMapsterEventsListeners(localVars.imageMapWr_jQObj);
           api.panMap();
           });
           });*/
          PlanWidget.publicAPI = publicApi;
        }
      );
    }
  })
  ;
})
(window);
